import React, { useEffect, useState } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Typography, Theme, Button } from '@material-ui/core';

// import {TabPanel} from '@material-ui/lab';
// Icon
import {
  useQueryClient,
  useQuery,
} from 'react-query';
import getVehiclesEntrances from '../requests/getVehiclesEntrances';
import { DriverCard } from '../components/driverCard';
import { removeEmptyValueObject } from '../../../utils/helpers';
import { flattenObject } from 'client-sdk/src/helpers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    driverCard: {
      marginTop: '56px',
    },
    infoIcon: {
      color: 'inherit',
    },
    infoSection: {
      color: '#2f4858',
      padding: '8px',
    },
    infoBar: {
      flexShrink: 1,
      display: 'inline',
    },
    namePlateText: {
      paddingLeft: '8px',
      fontSize: '18px',
    },
    namePlateNumber: {
      paddingLeft: '8px',
      fontSize: '14px',
    },
    namePlate: {
      flexShrink: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '8px',
    },
    parentGrid: {
      minWidth: '100%',
      backgroundColor: 'white',
      padding: '0px',
      marginTop: '16px',
    },
    idBar: {
      display: 'flex',
    },
    profileImage: {
      maxWidth: '48px',
      maxHeight: '48px',
      borderRadius: '50%',
    },
    root: {
      marginTop: '30px',
    },
  })
);


export const ActiveDriversMobView = (props: any) => {
  const classes = useStyles();
  const prefferedPageSize = 50;
  const placeHolderPageNumber = 1;

  let passableParams;

  const [statusFilterParams, setStatusFilterParams] = useState<any>();
  const [pageNumber, setPageNumber] = useState(1)


  useEffect(() => {
    const getVehiclesEntrancesParams = {
      // 'paged': true,
      'vehicleEntranceType.equals': props.filter,
      'status.equals': props.status,
      'pageNumber': pageNumber,
      'size': prefferedPageSize,
      'sort': 'id,desc',
    };

    passableParams = removeEmptyValueObject(
      flattenObject(getVehiclesEntrancesParams)
    );
    setStatusFilterParams(passableParams);
  }, [pageNumber]);

  const {
    isLoading,
    error,
    data: vehicles,
  } = useQuery(
    ['vehicles', statusFilterParams],
    () => getVehiclesEntrances(statusFilterParams),
    {
      staleTime: 5 * 60 * 1000, //5 min fresh data
      cacheTime: 10 * 60 * 1000, //3 minutes fresh
      enabled: !!statusFilterParams,
    }
  );

  if (isLoading) {
    return <Typography>شکیبا باشید</Typography>;
  }
  if (error) {
    console.log(error.message);
  }

  return (
    <>
      {
        vehicles?.data.length > 0 ? ( <>
          {
            vehicles.data.map((vehicle: any) => <DriverCard vehicle={vehicle} className={classes.driverCard} status={props.status} />)
          }
            {/* <div style={{display: "flex", justifyContent: "center"}}>
              <Button variant='contained' color='primary' onClick={() => setPageNumber(pageNumber + 1)}>
                بیشتر
              </Button>
            </div> */}
        </>) : <div>بدون راننده</div>
      }
    </>
  )
};
